// extracted by mini-css-extract-plugin
export default {"order-sec":"OrderPlaced_order-sec__2otoa","order-main-sec":"OrderPlaced_order-main-sec__0U7aj","footer":"OrderPlaced_footer__15f6s"};